module.exports = __webpack_public_path__ + "img/psychology.b4a10215.png";